<script>
  import Swiper from "swiper";
  import "swiper/swiper-bundle.css";
  import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper/core";
  SwiperCore.use([Navigation, Pagination, Autoplay]);

  export default {
    data() {
      return {
      };
    },
    mounted() {
      var swiper = new Swiper(this.$refs["mySwiper3"], {
        slidesPerView: 1,
        spaceBetween: 0,

        pagination: {
          el: this.$refs["swiper-pagination"],
          clickable: true,
        },

        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 50,
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 50,
          },
        },
      });
    },
    props: {
      group: null,
    },
    computed: {
    },
    methods: {
    },

  };
</script>

<template>
  <section id="vagas" class="job">
    <div class="container job__box">

        <div class="job__box__card">
          <div class="bg bg1"></div>
          <div class="text">
            <h3>
              Vagas Escritório
            </h3>
            <router-link to="/vagas?collection=escritorio" class="btn--job">
              VER OPORTUNIDADES
            </router-link>
          </div>
        </div>
        <div class="job__box__card">
          <div class="bg bg2"></div>
          <div class="text">
            <h3>
              Vagas Fábrica
            </h3>
            <router-link to="/vagas?collection=fabrica" class="btn--job">
              VER OPORTUNIDADES
            </router-link>
          </div>
        </div>
        <div class="job__box__card">
          <div class="bg bg3"></div>
          <div class="text">
            <h3>
              Vagas Loja
            </h3>
            <router-link to="/vagas?collection=loja" class="btn--job">
              VER OPORTUNIDADES
            </router-link>
          </div>
        </div>
        <div class="job__box__card">
          <div class="bg bg4"></div>
          <div class="text">
            <h3>
              Vagas CD
            </h3>
            <router-link to="/vagas?collection=cd" class="btn--job">
              VER OPORTUNIDADES
            </router-link>
          </div>
        </div>

    </div>

    <section class="container job__team">
      <header>
        <h2>Se você gosta de <strong>moda</strong>, de um ambiente descontraído, dinâmico e cheio de desafios,<br />
          <strong>vem para a Inbrands!</strong></h2>
        <h2>Se você se <strong>identificou</strong> com <strong>nosso jeito de ser, este é o seu Lugar!</strong></h2>
        <p>
          O nosso universo é plural e cheio de energia. Aqui as identidades e expressões de gênero e orientações afetivas são bem-vindas. Temos muito orgulho do nosso time cheio de diversidade!
        </p>
        <p>
          Buscamos pessoas com senso de urgência, criatividade, ousadia, otimismo, foco em resultados, persistência e que se entusiasmem com seu próprio inconformismo. Para que juntos possamos transformar cada vez mais nossas marcas e nossas pessoas.
        </p>
      </header>
    </section>

    <section class="job__videos" id="marcas-parceiras">
      <div class="container">

        <div
          class="swiper-container swiper2 mySwiper3"
          ref="mySwiper3"
        >
          <div class="swiper-wrapper">

            <div class="swiper-slide">
              <div class="job__videos__content">
                <video controls>
                  <source :src="require(`@/assets/videos/v2/ELLUS.mp4`)">
                </video>
              </div>

              <a href="https://www.inbrands.com.br/ellus/" target="_blank">
                <img
                  :src="require(`@/assets/videos/v2/ELLUS.png`)"
                  class=""
                  style="width: auto; height: 20px;"
                />
              </a>
            </div>

            <div class="swiper-slide">
              <div class="job__videos__content">
                <video controls>
                  <source :src="require(`@/assets/videos/v2/salinas.mp4`)">
                </video>
              </div>

              <a href="https://www.inbrands.com.br/salinas/" target="_blank">
                <img
                  :src="require(`@/assets/videos/v2/salinas.png`)"
                  class=""
                  style="width: auto; height: 20px;"
                />
              </a>
            </div>

            <div class="swiper-slide">
              <div class="job__videos__content">
                <video controls>
                  <source :src="require(`@/assets/videos/v2/richards.mp4`)">
                </video>
              </div>

              <a href="https://www.inbrands.com.br/richards/" target="_blank">
                <img
                  :src="require(`@/assets/videos/v2/richards.png`)"
                  class=""
                  style="width: auto; height: 20px;"
                />
              </a>
            </div>

            <div class="swiper-slide">
              <div class="job__videos__content">
                <video controls>
                  <source :src="require(`@/assets/videos/v2/tommy.mp4`)">
                </video>
              </div>

              <a href="https://www.inbrands.com.br/tommy-hilfiger/" target="_blank">
                <img
                  :src="require(`@/assets/videos/v2/tommy.png`)"
                  class=""
                  style="width: auto; height: 20px;"
                />
              </a>
            </div>

            <div class="swiper-slide">
              <div class="job__videos__content">
                <video controls>
                  <source :src="require(`@/assets/videos/v2/VR.mp4`)">
                </video>
              </div>

              <a href="https://www.inbrands.com.br/vr-collezioni/" target="_blank">
                <img
                  :src="require(`@/assets/videos/v2/VR.png`)"
                  class=""
                  style="width: auto; height: 20px;"
                />
              </a>
            </div>

          </div>
          <div class="swiper-pagination"  data-aos="fade-up" data-aos-duration="1000" ref="swiper-pagination"></div>
        </div>

      </div>
    </section>
  </section>
</template>

<style lang="scss" scoped src="../styles/job.scss">
  /deep/li{
    list-style: disc;
  }
</style>